import { Box, Button, Modal, Stack, Typography } from '@mui/material'

function AlertModal({
  content,
  open,
  handleClose,
}: {
  content: {
    msg: string
    header: string
    btnText: string
  }
  open: boolean
  handleClose: () => void
}) {
  return (
    <Modal
      open={open}
      //   onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { sx: 200, md: 400 },
          bgcolor: 'background.paper',
          borderRadius: 4,
          p: 4,
          border: '0px',
        }}
      >
        <Typography
          id="modal-modal-title"
          component="h2"
          sx={{ fontFamily: 'Sanomat-Medium-Web', fontSize: '25px', color: '#145a4b' }}
        >
          {content?.header}
        </Typography>

        <div
          dangerouslySetInnerHTML={{ __html: content?.msg }}
          style={{
            fontFamily: 'Atlas-Grotesk-Web-Regular',
            fontSize: '16px',
            marginTop: '20px',
            lineHeight: '20px',
          }}
        />
        <Stack direction="row" spacing={2} justifyContent={'flex-end'} marginTop={5}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              bgcolor: 'primary.main',
              color: 'white',
              borderRadius: '36px',
              fontWeight: 400,
              textTransform: 'uppercase',
              fontSize: '.9rem',
              padding: '8px 24px',
              letterSpacing: '2px',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
            }}
            onClick={handleClose}
          >
            {content?.btnText}
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}

export default AlertModal
